module.exports = __webpack_public_path__ + "img/round-rectangle.3db59510.svg";